// extracted by mini-css-extract-plugin
export default {"btn_more":"dots-btn_btn_more__aw0xv","dots_menu_wrapper":"dots-btn_dots_menu_wrapper__oxkYh","selected":"dots-btn_selected__ETx78","dots_menu":"dots-btn_dots_menu__O2cBw"};